module.exports = __webpack_public_path__ + "media/application/images/ui/filter-dropdown-cf06e89aaa0cdc2c557c1e778ed4ad9d.svg";